window.trimInput = (inputEl) ->
  inputEl.val inputEl.val()?.trim()

$("body").on "blur", "input", (e) ->
  trimInput $(this)
